@if (product.offering.id && isLoadingAdditionalServiceOfferings()) {
  <div class="spinner">
    <app-spinner />
  </div>
} @else {
  @if (isIceJunior) {
    <app-whitelist-entries-input [form]="whitelistEntryForm" />
  }
  @if (form && showServices) {
    @if (form.controls?.length > 0) {
      <p class="other-services-text">Andre tjenester</p>
    }
    <div class="additional-service-list" formArrayName="additionalServices">
      @if (product.phoneNumber.isOwnerChange) {
        <app-ice-alert class="owner-change-message" type="warning" [iconName]="IconNames.ice_info">
          Tvilling- og Data-SIM må bestilles på nytt og byttes ved Ice-eierskifte
        </app-ice-alert>
      }
      @for (service of simServices; track service.productId) {
        <app-additional-sim-group
          [rows]="simRows()[service.productId]"
          [service]="service"
          (add)="addSimRow(service)"
          (clear)="clearSimRows(service)"
          (remove)="removeSimRow(service, $event)"
        />
      }
      @for (item of mutexAndNonSimServiceControls; track $index) {
        <div>
          <div [formGroup]="$any(item)">
            @if (!item.get('isMutexService')) {
              @if (getAdditionalService($any(item)); as additionalService) {
                <app-additional-service
                  iccControlName="icc"
                  selectionControlName="selected"
                  simDeliveryControlName="simDelivery"
                  [additionalService]="additionalService"
                />
              }
            } @else {
              @if (getMutexService($any(item)); as mutexService) {
                <app-mutex-additional-service
                  mutexControlName="selectedMutexService"
                  selectionControlName="selected"
                  [mutexSet]="mutexService"
                />
              }
            }
          </div>
        </div>
      }
      @if (getVasProductFromOffering(product.offering); as vasProduct) {
        <div class="offering-vas">
          <h3>{{ getUniqueSellingPointsTitle(vasProduct.productName) }}</h3>
          <app-ice-pill [type]="'primary'" (click)="onVasClick()">
            <div class="offering-vas-content">
              {{ vasProduct.productName }}
              <span>{{ vasProduct.monthlyPrice?.price | priceFormat: PriceType.Monthly : 'Inkludert' }}</span>
            </div>
          </app-ice-pill>
        </div>
      }
    </div>
  }
}
@if (!product.offering.id) {
  <app-ice-alert type="neutral" [iconName]="IconNames.ice_info">Abonnement ikke valgt</app-ice-alert>
}
